import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import MemberProfile from "../../member/profile/components/MemberProfile";
import References from "../components/references/References";
import RejectMemberModal from "../components/rejectMemberModal/RejectMemberModal";

import * as commonActions from "../../../../actions/common.actions";
import * as adminActions from "../../../../actions/admin.actions";
import * as userActions from "../../../../actions/user.actions";
import * as dropdownsActions from "../../../../actions/dropdowns.actions";

import styles from "./MemberModerationContainer.scss";

const subHeader = activeItem => {
  return {
    items: [
      {
        caption: "Applied"
      },
      {
        caption: "References"
      },
      {
        caption: "Interview"
      },
      {
        caption: "Accepted"
      }
    ],
    arrows: true,
    activeItem
  };
};

const newApplicationHeaderBar = (
  rejectAplication,
  contactApplicant,
  requestReferences,
  memberName
) => ({
  color: "blue",
  flexDirection: "column",
  title: "New Application",
  text:
    "This is a new application for membership. You can reject her application, contact her for more information, " +
    "or graduate her to the references stage. Click Admin Activity for more detail about her application.",
  buttons: [
    {
      text: "Reject Application",
      type: "modalTrigger",
      modalProps: {
        memberName,
        rejectMember: rejectAplication
      },
      modal: RejectMemberModal
    },
    {
      text: "Contact Applicant",
      onClick: contactApplicant
    },
    {
      color: "blue",
      text: "Request References",
      onClick: requestReferences
    }
  ]
});

const referenceCheckHeaderBar = (
  rejectAplication,
  contactApplicant,
  scheduleInterview,
  memberName
) => ({
  color: "blue",
  flexDirection: "column",
  title: "Reference Check",
  text:
    "This applicant’s references have been contacted. Scroll down to view and approve or reject " +
    "each reference. Once all three references are approved, the applicant will be moved to the next round.",
  buttons: [
    {
      text: "Reject Application",
      type: "modalTrigger",
      modalProps: {
        memberName,
        rejectMember: rejectAplication
      },
      modal: RejectMemberModal
    },
    {
      text: "Contact Applicant",
      onClick: contactApplicant
    },
    {
      color: "blue",
      text: "Schedule Interview",
      onClick: scheduleInterview
    }
  ]
});

const interviewAndAcceptHeaderBar = (
  rejectAplication,
  contactApplicant,
  approveApplication,
  memberName
) => ({
  color: "green",
  flexDirection: "column",
  title: "Interview & Accept",
  text:
    "This applicant’s references have been approved. Contact her to schedule an interview, then approve " +
    "or reject the member based on the interview.",
  buttons: [
    {
      text: "Reject Application",
      type: "modalTrigger",
      modalProps: {
        memberName,
        rejectMember: rejectAplication
      },
      modal: RejectMemberModal
    },
    {
      text: "Contact Applicant",
      onClick: contactApplicant
    },
    {
      color: "green",
      text: "Approve Application",
      onClick: approveApplication
    }
  ]
});

const approvedHeaderBar = () => ({
  color: "green",
  flexDirection: "column",
  title: "Approved",
  text: "This member is now available for matching and pitching."
});

const applicationRejectedHeaderBar = (contactApplicant, reviveApplication) => ({
  color: "grey",
  flexDirection: "column",
  title: "Application Rejected",
  text:
    "This candidate’s application was rejected. View Admin Activiy for more information. " +
    "Click below to contact the user, or click “revive” if her application was rejected by mistake.",
  buttons: [
    {
      text: "Contact Applicant",
      onClick: contactApplicant
    },
    {
      color: "grey",
      text: "Revive Application",
      onClick: reviveApplication
    }
  ]
});

class MemberModerationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      memberStatus: null,
      currentPageIndex: null
    };

    this.props.adminActions.getUser(this.props.match.params.memberId);
    this.props.userActions.getUserStatusList();
    this.props.dropdownsActions.fetchWorkRelationships();

    this.contactApplicant = this.contactApplicant.bind(this);

    this.rejectAplication = this.rejectAplication.bind(this);
    this.requestReferences = this.requestReferences.bind(this);
    this.scheduleInterview = this.scheduleInterview.bind(this);
    this.approveApplication = this.approveApplication.bind(this);
    this.reviveApplication = this.reviveApplication.bind(this);

    this.sendReminderReference = this.sendReminderReference.bind(this);
    this.approveReference = this.approveReference.bind(this);
    this.rejectReference = this.rejectReference.bind(this);
    this.addReference = this.addReference.bind(this);

    this.downloadResume = this.downloadResume.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setSubHeader(prevState);
    this.setHeaderBar(prevState);
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  setSubHeader(prevState) {
    const member = this.props.admin.user;
    const memberStatus = _.get(member, "status.name");

    const possibleSubHeaders = {
      "account-created": subHeader(0),
      applied: subHeader(0),
      "waiting-for-references": subHeader(1),
      "pending-interview": subHeader(2),
      approved: subHeader(3),
      rejected: subHeader()
    };

    if (
      possibleSubHeaders[memberStatus] &&
      memberStatus !== prevState.memberStatus
    ) {
      this.props.commonActions.setSubHeader(possibleSubHeaders[memberStatus]);
    }
  }

  setHeaderBar(prevState) {
    const member = this.props.admin.user;
    const memberStatus = _.get(member, "status.name");
    const memberName = member.first_name + " " + member.last_name;
    /* leaving this here in the case someone wants to add this condition again */
    const scheduleInterviewDisabled = this.isScheduleInterviewDisabled();

    const possibleHeaderBars = {
      "account-created": newApplicationHeaderBar(
        this.rejectAplication,
        this.contactApplicant,
        this.requestReferences,
        memberName
      ),
      applied: newApplicationHeaderBar(
        this.rejectAplication,
        this.contactApplicant,
        this.requestReferences,
        memberName
      ),
      "waiting-for-references": referenceCheckHeaderBar(
        this.rejectAplication,
        this.contactApplicant,
        this.scheduleInterview,
        memberName
      ),
      "pending-interview": interviewAndAcceptHeaderBar(
        this.rejectAplication,
        this.contactApplicant,
        this.approveApplication,
        memberName
      ),
      approved: approvedHeaderBar(),
      rejected: applicationRejectedHeaderBar(
        this.contactApplicant,
        this.reviveApplication
      )
    };

    if (
      possibleHeaderBars[memberStatus] &&
      (memberStatus !== prevState.memberStatus ||
        scheduleInterviewDisabled !== prevState.scheduleInterviewDisabled)
    ) {
      this.props.commonActions.setHeaderBar(possibleHeaderBars[memberStatus]);
      this.setState({ memberStatus, scheduleInterviewDisabled });
    }
  }

  isScheduleInterviewDisabled() {
    /* leaving this here in the case someone wants to add this condition again */
    const REQUIRED_APPROVALS = 2;
    const references = _.get(this.props.admin, "user.work_references") || [];
    let approvedReferencesCount = 0;

    references.forEach(reference => {
      if (reference.approval && reference.approval.approved) {
        approvedReferencesCount += 1;
      }
    });

    return approvedReferencesCount < REQUIRED_APPROVALS;
  }

  contactApplicant() {
    const link = `mailto:${this.props.admin.user.email}`;
    const emailWindow = window.open(link, "emailWindow");

    setTimeout(() => {
      if (emailWindow && emailWindow.open && !emailWindow.closed) {
        emailWindow.close();
      }
    }, 0);
  }

  downloadResume(e) {
    e.preventDefault();

    // Flag to know if we need to download the resume or just view (open) it
    const download = e.target.dataset.download === "true";

    if (this.props.match.params.memberId) {
      this.props.userActions.downloadResume(
        this.props.match.params.memberId,
        download
      );
    }
  }

  /* update member status functions */

  updateUser(statusName, comments) {
    const status = _.find(this.props.user.userStatusList, { slug: statusName });

    this.props.adminActions.updateUser({
      user_id: this.props.match.params.memberId,
      status_id: status.id,
      comments
    });
  }

  rejectAplication(form) {
    this.updateUser("rejected", form.comments);
  }

  requestReferences() {
    this.updateUser("waiting-for-references");
  }

  scheduleInterview() {
    this.updateUser("pending-interview");
  }

  approveApplication() {
    this.updateUser("approved");
  }

  reviveApplication() {
    this.updateUser("applied");
  }

  /* update reference status functions */

  sendReminderReference(reference_id) {
    this.props.adminActions.sendReminderReference({
      reference_id
    });
  }

  approveReference(reference_id) {
    const userId = this.props.match.params.memberId;

    this.props.adminActions.approveReference(
      {
        reference_id,
        approved: true
      },
      userId
    );
  }

  rejectReference(reference_id) {
    const userId = this.props.match.params.memberId;

    this.props.adminActions.approveReference(
      {
        reference_id,
        approved: false
      },
      userId
    );
  }

  addReference(data) {
    data.user_id = this.props.match.params.memberId;

    this.props.adminActions.adminAddReference(data);
  }

  filterNoRejectedReferences() {
    const references = _.get(this.props.admin, "user.work_references") || [];

    //return the no rejected references
    return references.filter(reference => {
      const approved = _.get(reference, "approval.approved");
      const declined = _.get(reference, "declined");

      return approved !== false && !declined;
    });
  }

  render() {
    const member = this.props.admin.user;
    const memberStatus = _.get(member, "status.name");

    const references = this.filterNoRejectedReferences();
    const referencesProps = {
      references,
      memberName: member.first_name + " " + member.last_name,
      memberEmail: this.props.admin.user.email,
      approveReference: this.approveReference,
      rejectReference: this.rejectReference,
      sendReminderReference: this.sendReminderReference,
      addReference: this.addReference,
      workRelations: this.props.workRelations
    };

    const fullMemberModerationComponent = (
      <div>
        <MemberProfile
          memberData={member}
          downloadResume={this.downloadResume}
        />
        <div className={styles.doubleBorder} />
        <References {...referencesProps} />
      </div>
    );

    const appliedMemberModerationComponent = (
      <div>
        <MemberProfile
          memberData={member}
          downloadResume={this.downloadResume}
        />
        <div className={styles.doubleBorder} />
        <References {...referencesProps} />
      </div>
    );

    const possibleComponents = {
      "account-created": appliedMemberModerationComponent,
      applied: appliedMemberModerationComponent,
      "waiting-for-references": fullMemberModerationComponent,
      "pending-interview": fullMemberModerationComponent,
      approved: fullMemberModerationComponent,
      rejected: (
        <MemberProfile
          memberData={member}
          downloadResume={this.downloadResume}
        />
      )
    };

    return possibleComponents[memberStatus] || null;
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin,
    user: state.user,
    workRelations: state.dropdowns.workRelationship.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
    downloadResume: (userId, download) =>
      dispatch(downloadResume(userId, download))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberModerationContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/memberModeration/containers/MemberModerationContainer.js